import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Button from "components/CustomButtons/Button.js";

import videoStyle from "assets/jss/material-kit-pro-react/views/salesSections/videoStyle.js";

import introVideo from "assets/videos/introduction.mp4";

const useStyles = makeStyles(videoStyle);

export default function SectionTeam() {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}>Online Courses</h4>
      <div className={classes.iframeContainer}>
        <video width="100%" controls autoPlay muted>
          <source src={introVideo} type="video/mp4" />
        Your browser does not support the video tag.
        </video>
      </div>
      <div style={{ marginTop: 20 }}>
        <p className={classes.body5 + " " + classes.textCenter}>For the last 15 years, Utah Swim Academy, has been teaching lifesaving water safety skills to infants, children, teens and even adults at our Utah facility. </p>
        <p className={classes.body5 + " " + classes.textCenter}>The Utah Swim Academy Online Course will help bring the knowledge and expertise to your own school - armed with a unique personality-based approach to teaching swimming that no one else offers.</p>
        <p className={classes.body5 + " " + classes.textCenter}>Start Learning Today!</p>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          href="https://utah-swim-academy.teachable.com/p/complete-series"
          color={"info"}
          target="_blank"
          size="lg"
          className={classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter}
          round
        >
          Buy Now
        </Button>
      </div>
    </div>
  );
}
